import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import DayPicker, { DateUtils } from 'react-day-picker';
import { Popover } from 'reactstrap';
import { addDays, addMonths, endOfDay, format, startOfDay, startOfMonth, subDays } from 'date-fns';
import filterProps from '../utils/filterProps';
export class DateRangePicker extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
            from: startOfDay(subDays(new Date(), 14)),
            to: endOfDay(new Date()),
        };
        this.handleToggleOpen = (event) => {
            if (event.target.closest('.DayPicker')) {
                return;
            }
            this.setState((prevState) => {
                return {
                    open: !prevState.open,
                };
            });
        };
        this.handleDayClick = (day) => {
            let range = DateUtils.addDayToRange(day, {
                from: this.state.from,
                to: this.state.to,
            });
            range = {
                from: startOfDay(range.from || this.state.from),
                to: endOfDay(range.to || this.state.to),
            };
            if (range.to && range.to.getTime() > new Date().getTime()) {
                range.to = endOfDay(new Date());
            }
            this.setState(range);
        };
        this.handleSubmit = () => {
            const range = this.state;
            if (range.from && range.to && this.props.onChangeDates) {
                this.props.onChangeDates(range);
            }
        };
    }
    UNSAFE_componentWillReceiveProps(props) {
        this.setState((prevState) => {
            return {
                from: props.from ? new Date(props.from) : prevState.from,
                to: props.to ? new Date(props.to) : prevState.to,
            };
        });
    }
    renderPicker() {
        const { t } = this.props;
        const { from, to } = this.state;
        const disabledDays = [];
        const endOfMonth = startOfMonth(addMonths(new Date(), 1)).getTime();
        for (let day = addDays(new Date(), 1); day.getTime() < endOfMonth; day = addDays(day, 1)) {
            disabledDays.push(new Date(day));
        }
        return (_jsxs("div", { className: "picker__datetime-range-picker", children: [_jsx(DayPicker, { disabledDays: disabledDays, firstDayOfWeek: 1, locale: this.props.lng, modifiers: { start: from, end: to }, numberOfMonths: this.props.browser.greaterThan.small ? 3 : 1, onDayClick: this.handleDayClick, selectedDays: [from, { from, to }], 
                    // showOutsideDays
                    toMonth: new Date() }), _jsxs("p", { className: "datetime-range-picker__footer", children: [t('resultsComparedPeriod'), _jsx("button", { className: "datetime-range-picker__button", onClick: this.handleSubmit, children: t('apply') })] })] }));
    }
    render() {
        const { className, t, ...rest } = filterProps(this.props, [
            'from',
            'to',
            'onChangeDates',
            'browser',
            'dispatch',
            'i18n',
            'lng',
            'tReady',
        ]);
        const { open, from, to } = this.state;
        // const dateFormat = t(browser.greaterThan.small ? 'datePickerFormat' : 'datePickerShortFormat');;
        const dateFormat = t('datePickerFormat');
        return (_jsxs("div", { ...rest, className: clsx('picker picker--datetime-range', open && 'picker--datetime-range-open', className), onClick: this.handleToggleOpen, children: [_jsxs("div", { className: "picker__value", ref: (ref) => (this.inputRef = ref), children: [format(from, dateFormat), " -", ' ', format(to, dateFormat)] }), !this.inputRef ? null : (_jsx(Popover, { isOpen: open, placement: "bottom-end", target: this.inputRef, toggle: this.handleToggleOpen, trigger: "legacy", fade: false, children: this.renderPicker() }))] }));
    }
}
DateRangePicker.defaultProps = {
    className: '',
};
const mapStateToProps = (state) => ({
    browser: state.browser,
});
export default connect(mapStateToProps)(withTranslation()(DateRangePicker));
